if (!customElements.get('site-tabs')) {
  class SiteTabs extends HTMLElement {

    constructor() {
      super();
      this.listeners();
    }

    listeners() {
      const self = this;
      const tabLinks = this.querySelectorAll('.js-tabs-link');

      tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('click', (e) => {
          const targetId = tabLink.getAttribute('data-tab');

          e.preventDefault();

          if (targetId) {
            this.showTab(targetId, tabLink);
          }
        })
      });

      document.addEventListener('tab:show', (e) => {
        const targetId = e.detail.data.tab;

        if (targetId) {   
          const tabLink = self.querySelector(`.js-tabs-link[data-tab="${targetId}"]`);

          if (tabLink) {
            this.showTab(targetId, tabLink);
          }
        }
      });
    }

    showTab(targetId, tabLink) {
      const tabs = this.querySelectorAll('.js-tabs-content');
      const targetTab = document.querySelector(targetId);
      const tabLinks = this.querySelectorAll('.js-tabs-link');

      if (targetTab) {
        const otherTabLinks = [...tabLinks].filter((otherTabLink) => otherTabLink !== tabLink);
        const otherTabs = [...tabs].filter((otherTab) => otherTab !== targetTab)

        otherTabLinks.forEach((otherTabLinks) => {
          otherTabLinks.classList.remove('active');

          if (otherTabLinks.getAttribute('data-tab') === targetId) {
            otherTabLinks.classList.remove('active');
          }
        });

        otherTabs.forEach((otherTab) => {
          otherTab.classList.remove('active');
        });
      }

      tabLink.classList.add('active');
      targetTab.classList.add('active');
    }
  }

  customElements.define('site-tabs', SiteTabs);
}
